import { envSchema } from './env-schema'

export const config = envSchema.parse(import.meta.env)
